/** PURE_IMPORTS_START .._.._Observable,.._.._observable_defer PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { defer as staticDefer } from '../../observable/defer';
Observable.defer = staticDefer;
//# sourceMappingURL=defer.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/observable/defer.js
// module id = 618
// module chunks = 0